import { render, staticRenderFns } from "./CallUpdateIssuesCategories.vue?vue&type=template&id=21be3a91"
import script from "./CallUpdateIssuesCategories.vue?vue&type=script&lang=js"
export * from "./CallUpdateIssuesCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports